export default "__VITE_ASSET__DkuyM5sf__"